import React from 'react'
import Container from 'react-bootstrap/Container';

function Footer() {
  return (
    <Container fluid  className="border-top mt-2 text-center bg-light text-dark py-3">
        <p className="m-0">Resume Builder</p>
    </Container>
  )
}

export default Footer